import React from 'react';
import { ButtonToolbar, ControlLabel, FormGroup } from 'react-bootstrap';
import GroupSearchSelect from '../../../GroupSearchSelect.jsx';

const ParentGroupSelect = ({
  groups,
  groupId,
  parentId,
  groupsFieldTitle,
  handleSelect,
  disabled,
}) => {
  const filterCurrentGroup = (groupList) => {
    return groupList.reduce((filtered, group) => {
      if (group.id === groupId) {
        if (group.children?.length > 0) {
          filtered.push(...filterCurrentGroup(group.children));
        }
      } else {
        const filteredChildren = group.children
          ? filterCurrentGroup(group.children)
          : [];
        filtered.push({
          ...group,
          children: filteredChildren,
        });
      }
      return filtered;
    }, []);
  };

  const filteredGroups = filterCurrentGroup(groups);

  const selectedGroups = parentId ? { [parentId]: true } : {};

  const handleGroupSelect = (group) => {
    if (parentId === group.id) {
      handleSelect(null);
    } else {
      handleSelect(group.id);
    }
  };

  const findGroupById = (groupList, targetId) => {
    for (const group of groupList) {
      if (group.id === targetId) {
        return group;
      }
      if (group.children && group.children.length > 0) {
        const found = findGroupById(group.children, targetId);
        if (found) return found;
      }
    }
    return null;
  };

  const selectedGroup = parentId ? findGroupById(groups, parentId) : null;
  const title = selectedGroup
    ? selectedGroup.name
    : groupsFieldTitle || 'No Parent';

  return (
    <FormGroup>
      <ControlLabel>Parent Group</ControlLabel>
      <ButtonToolbar>
        <GroupSearchSelect
          groups={filteredGroups}
          selectedGroups={selectedGroups}
          onSelectGroup={handleGroupSelect}
          title={title}
          disabled={disabled}
          className="btn-block"
          style={{ height: '36px' }}
        />
      </ButtonToolbar>
    </FormGroup>
  );
};

export default ParentGroupSelect;
